import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Row,
  Col,
  Panel
 } from 'react-bootstrap';

const JNInitWizardPageSix = ({
  merge_options,
  field_map,
  jn_fields,
  type_default,
  status_default
}) => {
  const { direction, merge_key, dominant_set } = merge_options;

  return (
    <div className='jn-init-wizard-pg-five-container'>
      <h4>Please Review Your Integration Options :</h4>
      <p>
        ** This process may make changes to your Hail Trace and/or Job Nimbus data.{' '}
        You will be able to reset your Hail Trace data after the integration is complete,{' '}
        but please contact the administration with any questions if you are uncertain.
      </p>
      <hr className='dotted short' />
      <Panel>
        {direction == 'into_ht' ? (
          `Clear Hail Trace data and initialize clients with my Job Nimbus contacts' data.`
        ) : (
          <div>
            <ul>
              <li>
                Merge Hail Trace and Job Nimbus data together.
              </li>
              <li>
                Use <strong>{merge_key}</strong> as the merge key.
              </li>
              <li>
                {dominant_set == 'ht' ? 'Hail Trace ' : 'Job Nimbus '} will be the dominant data set.
              </li>
            </ul>
            
            <hr className='dotted short' />
            
            {Object.keys(field_map).length > 0 ? (
              <div>
                <p>Hail Trace to Job Nimbus field map :</p>
                <Row>
                  <Col xs={4} md={4} xsOffset={1} mdOffset={1}>
                    <strong><u>Hail Trace</u></strong>
                  </Col>
                  <Col xs={4} md={4} xsOffset={1} mdOffset={1}>
                    <strong><u>JobNimbus</u></strong>
                  </Col>
                </Row>
                {Object.keys(field_map).map((field, idx) => {
                  const current_jn_field = jn_fields.find(f => f.field == field);
                  const current_ht_field = field_map[current_jn_field.field];
                  if(!current_jn_field || !current_ht_field) debugger;

                  return (
                    <div key={idx}>
                      <Row>
                        <Col xs={4} md={4} xsOffset={1} mdOffset={1}>
                          {current_ht_field}
                        </Col>
                        <Col xs={1} md={1}>
                          <i className='fa fa-arrows-h' />
                        </Col>
                        <Col xs={6} md={6}>
                          {current_jn_field.title}
                        </Col>
                      </Row>
                    </div>
                  );
                })}
              </div>
            ) : null}
            
            <hr className='dotted short' />
            
            <p>Default Contact Type: {type_default.label}</p>
            <p>Default Status : {status_default.label}</p>
          </div>
        )}
      </Panel>
    </div>
  );
}

export default JNInitWizardPageSix;



// WEBPACK FOOTER //
// ./src/browser/components/settings/integrations/jobnimbus/jn-init-wizard-pg-six.js